import { render } from "./Checkbox.vue?vue&type=template&id=63345eee&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=63345eee&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.26.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63345eee"]])

export default __exports__